import { render, staticRenderFns } from "./admin-setting-nav.vue?vue&type=template&id=e1057c18&scoped=true&"
import script from "./admin-setting-nav.vue?vue&type=script&lang=js&"
export * from "./admin-setting-nav.vue?vue&type=script&lang=js&"
import style0 from "./admin-setting-nav.vue?vue&type=style&index=0&id=e1057c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1057c18",
  null
  
)

export default component.exports